import React from 'react';
import styled from 'styled-components';
// single line need to make component
const SingleLine = styled.div`
  width: ${(props) =>
    props.SingleLineWidth ? props.SingleLineWidth : '240px'};
  height: ${(props) =>
    props.SingleLineHeight ? props.SingleLineHeight : '15px'};
`;

const NavigationLoading = (props) => {
  const { rows = 3 } = props;

  return (
    <div className="sops-header-loader">
      <div className="sk-step-nav-wrap">
        {Array.from({ length: rows }, (_, i) => (
          <div className="pb-8">
            {Array.from({ length: 1 }, (_, i) => (
              <SingleLine
                className="sops-single-line flick-animation mb20"
                SingleLineWidth="200px"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NavigationLoading;
